import React from 'react';
import { Card, CardContent, CardFooter } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { MessageCircle, Eye, Building2 } from 'lucide-react';
export interface Brand {
  id: string;
  name: string;
  logo?: string;
  status: 'active' | 'pending' | 'inactive';
  lastContact: string;
  contactPerson: {
    name: string;
    email: string;
  };
}
interface BrandCardProps {
  brand: Brand;
}
export function BrandCard({
  brand
}: BrandCardProps) {
  const statusVariant = brand.status === 'active' ? 'success' : brand.status === 'pending' ? 'warning' : 'secondary';
  return <Card className="hover:shadow-md transition-shadow" data-id="element-63">
      <CardContent className="pt-6 flex flex-col items-center text-center" data-id="element-64">
        <div className="h-16 w-16 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-65">
          {brand.logo ? <img src={brand.logo} alt={brand.name} className="h-full w-full rounded-full object-cover" data-id="element-66" /> : <Building2 className="h-8 w-8 text-gray-400" data-id="element-67" />}
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-68">{brand.name}</h3>
        <Badge variant={statusVariant} className="mb-4 capitalize" data-id="element-69">
          {brand.status}
        </Badge>

        <div className="w-full space-y-2 text-sm text-gray-500 mb-4" data-id="element-70">
          <div className="flex justify-between" data-id="element-71">
            <span data-id="element-72">Last Contact:</span>
            <span className="font-medium text-gray-700" data-id="element-73">
              {brand.lastContact}
            </span>
          </div>
          <div className="flex justify-between" data-id="element-74">
            <span data-id="element-75">Contact:</span>
            <span className="font-medium text-gray-700" data-id="element-76">
              {brand.contactPerson.name}
            </span>
          </div>
        </div>
      </CardContent>
      <CardFooter className="bg-gray-50 p-4 flex gap-2" data-id="element-77">
        <Button variant="secondary" size="sm" className="flex-1" data-id="element-78">
          <MessageCircle className="h-4 w-4 mr-2" data-id="element-79" /> Message
        </Button>
        <Button variant="ghost" size="sm" className="flex-1" data-id="element-80">
          <Eye className="h-4 w-4 mr-2" data-id="element-81" /> Details
        </Button>
      </CardFooter>
    </Card>;
}